/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetCampaignSettingsQueryResponse,
  GetCampaignSettingsPathParams,
  GetCampaignSettings404,
} from '../../types/GetCampaignSettings'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCampaignSettings } from '../../clients/getCampaignSettings'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCampaignSettingsQueryKey = ({
  campaign_id,
}: {
  campaign_id: GetCampaignSettingsPathParams['campaign_id']
}) =>
  [
    {
      url: '/api/v1/emailbison/campaigns/:campaign_id/settings/',
      params: { campaign_id: campaign_id },
    },
  ] as const

export type GetCampaignSettingsQueryKey = ReturnType<
  typeof getCampaignSettingsQueryKey
>

export function getCampaignSettingsQueryOptions(
  {
    campaign_id,
  }: { campaign_id: GetCampaignSettingsPathParams['campaign_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getCampaignSettingsQueryKey({ campaign_id })
  return queryOptions<
    GetCampaignSettingsQueryResponse,
    ResponseErrorConfig<GetCampaignSettings404>,
    GetCampaignSettingsQueryResponse,
    typeof queryKey
  >({
    enabled: !!campaign_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getCampaignSettings(
        { campaign_id: campaign_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Get campaign settings.
 * Returns:
 * Campaign settings if BisonCampaign exists, null otherwise
 * @summary Get campaign settings
 * {@link /api/v1/emailbison/campaigns/:campaign_id/settings/}
 */
export function useGetCampaignSettings<
  TData = GetCampaignSettingsQueryResponse,
  TQueryData = GetCampaignSettingsQueryResponse,
  TQueryKey extends QueryKey = GetCampaignSettingsQueryKey,
>(
  {
    campaign_id,
  }: { campaign_id: GetCampaignSettingsPathParams['campaign_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCampaignSettingsQueryResponse,
        ResponseErrorConfig<GetCampaignSettings404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getCampaignSettingsQueryKey({ campaign_id })

  const query = useQuery(
    {
      ...getCampaignSettingsQueryOptions({ campaign_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetCampaignSettings404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
